import { Modal, Button } from "../../../evo/bootstrap";
import "../../assets/chatbotconfig.css"
import bookimage from "../../assets/book1.png"
import contactimage from "../../assets/contact.png"
import agentimage from "../../assets/agent3.png"
import excludeimage from "../../assets/exclude.png"
import cancelimage from "../../assets/CancelBooking.png"
import groupimage from "../../assets/groupurl.png"

const tooltipData = {
  agent: {
    title: "Talk to an Agent",
    image: agentimage
  },
  booknow: {
    title: "Book Now",
    image: bookimage
  },
  contact: {
    title: "Contact Us",
    image: contactimage
  },
  exclude: {
    title: "Exclude Keywords",
    image: excludeimage
  },
  cancel_modify: {
    title: "Cancel/Modify Booking",
    image: cancelimage
  },
  groupurl: {
    title: "Group Booking URL",
    image: groupimage
  },
  autopopup: {
    title: "Auto pop-up",
    image: null,
    description: "Auto open SwiftAssist widget on website"
  },
  autopopuptimer: {
    title: "Seconds",
    image: null,
    description: "Enter the number of seconds after which the SwiftAssist widget will automatically open on your website. For example, entering 5 will open the widget 5 seconds after the page loads."
  },
  widgetsecurity: {
    title: "Widget Security",
    image: null,
    description: "This section manages your widget authentication settings. Generate and manage your widget key securely. The key is used to validate requests from your website."
  },
  alloweddomains: {
    title: "Allowed Domains",
    image: null,
    description: "Specify the domains where this widget is allowed to run. Only requests originating from these domains will be accepted. You can add multiple domains, including subdomains (e.g., *.example.com)."
  }
};

const InfoImage = ({ show, onHide, buttonName }: any) => {
  const data = tooltipData[buttonName] || {
    title: "Information",
    image: null
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      dialogClassName={`info-tooltip-modal${!data.image ? ' info-tooltip-text-only' : ''}`}
      contentClassName="border-0 rounded-4 shadow-lg"
    >
      <Modal.Header closeButton className="border-bottom-0 pb-2">
        <Modal.Title className="fs-6 fw-bold text-primary">
          <i className="bi bi-info-circle me-2"></i>
          {data.title}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="pt-0 pb-3 px-3">
        {data.image ? (
          <div className="d-flex justify-content-center align-items-center">
            <img
              src={data.image}
              alt={data.title}
              className="rounded-3"
              style={{
                maxWidth: "100%",
                height: "auto",
                objectFit: "contain"
              }}
            />
          </div>
        ) : data.description ? (
          <div className="text-center">
            <p className="mb-0" style={{ fontSize: "14px", lineHeight: "1.6", color: "#495057" }}>
              {data.description}
            </p>
          </div>
        ) : null}
      </Modal.Body>

      <Modal.Footer className="border-top-0 pt-0 justify-content-center">
        <Button
          onClick={onHide}
          className="btn btn-primary btn-sm px-4"
        >
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default InfoImage;
